import { Component, inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { map } from "rxjs";
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from "@angular/common";
import { PivPiedPageComponent } from "src/app/zzz/ui/piv-pied-page/piv-pied-page.component";

@Component({
    templateUrl: './nous-joindre.component.html',
    styleUrls: ['./nous-joindre.component.scss'],
    imports: [
        TranslateModule,
        CommonModule,
        PivPiedPageComponent
    ]
})
export class NousJoindreComponent {
  #activeRoute = inject(ActivatedRoute);
  courrielSupport$ = this.#activeRoute.data.pipe(
    map(rep => rep.courrielSupport)
  );
}
